import { render } from "./edit-client-subtype.vue?vue&type=template&id=7504dfba&lang=html"
import script from "./edit-client-subtype.vue?vue&type=script&lang=js"
export * from "./edit-client-subtype.vue?vue&type=script&lang=js"

import "./edit-client-subtype.vue?vue&type=style&index=0&id=7504dfba&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__